<template>
	<div class="contact-form-component uk-position-relative">
		<form
			method="post"
			id="contact-form"
			accept-charset="UTF-8"
			@submit.prevent="submitForm"
		>
			<fieldset class="uk-fieldset contact-fields">
				<input type="hidden" :name="csrfName" :value="csrfToken" />
				<input type="hidden" name="message[ip]" :value="userIP" />
				<div class="contact-field">
					<label for="from-name">Je naam</label>
					<input
						id="from-name"
						type="text"
						class="uk-input"
						name="fromName"
						autocomplete="name"
						v-model="formData.name"
						:placeholder="placeholders.name"
						required
					/>
				</div>
				<div class="contact-field">
					<label for="from-email">E-mailadres</label>
					<input
						id="from-email"
						type="email"
						class="uk-input"
						name="fromEmail"
						autocomplete="email"
						v-model="formData.email"
						:placeholder="placeholders.email"
						required
					/>
				</div>
				<div class="contact-field contact-field--wide">
					<label for="subject">Onderwerp</label>
					<input
						id="subject"
						type="text"
						class="uk-input"
						name="subject"
						v-model="formData.subject"
						:placeholder="placeholders.subject"
						required
					/>
				</div>
				<div class="contact-field contact-field--wide">
					<label for="message">Je bericht of linktip</label>
					<textarea
						rows="4"
						cols="30"
						class="uk-textarea"
						id="message"
						name="message[body]"
						v-model="formData.message"
						:placeholder="placeholders.message"
						required
					></textarea>
				</div>
				<input
					type="submit"
					class="uk-button uk-button-primary contact-submit"
					:value="buttonText"
					:disabled="loading"
				/>
			</fieldset>
		</form>
		<div class="overlay" v-show="overlay">
			<div class="uk-position-center">
				<div class="uk-text-center">
					<span v-show="loading"
						><loading-indicator></loading-indicator
					></span>
					<span v-show="error" class="material-symbols-outlined"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							height="24"
							viewBox="0 -960 960 960"
							width="24"
						>
							<path
								d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
							/></svg
					></span>
					<span v-show="success" class="material-symbols-outlined"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							height="24"
							viewBox="0 -960 960 960"
							width="24"
						>
							<path
								d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
							/></svg
					></span>
				</div>
				<p class="uk-text-center">{{ feedbackMessage }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'ContactForm',
	components: {
		LoadingIndicator
	},
	props: {
		csrf: {
			type: Object,
			default () {
				return {
					tokenName: null,
					tokenValue: null
				}
			}
		},
		message: {
			type: String,
			required: false,
		},
		subject: {
			type: String,
			required: false,
		},
		userIP: String,
		placeholders: {
			type: Object,
			required: false,
			default () {
				return {
					name: 'Je naam',
					email: 'Emailadres',
					subject: 'Onderwerp',
					message: 'Bericht'
				}
			}
		},
		buttonText: {
			type: String,
			default: 'Versturen'
		},
		recaptchaSiteKey: {
			type: String
		}
	},
	data() {
		return {
			formData: {
				name: '',
				email: '',
				subject: '',
				message: this.message || '',
			},
			overlay: false,
			loading: false,
			error: false,
			errors: {},
			success: false,
			feedbackMessage: null,
			feedbackTimer: null,
		}
	},
	computed: {
		csrfName() {
			return this.csrf.tokenName || window.csrfTokenName
		},
		csrfToken() {
			return this.csrf.tokenValue || window.csrfTokenValue
		},
	},
	mounted() {
		this.$logger('Vue/component/contact-form/mounted');

		var component = this;
		if (component.subject) {
			component.formData.subject = component.subject;
		}
		if (component.message) {
			component.formData.message = component.message;
		}
	},
	created() {
		this.$logger('Vue/component/contact-form/created');
	},
	beforeUnmount() {
		clearTimeout(this.feedbackTimer);
	},
	methods: {
		formatErrors(errors) {
			return [...new Set(Object.values(errors || {}).flat().filter(message => typeof message === 'string'))].join(' ');
		},
		resetMessage() {
			clearTimeout(this.feedbackTimer);
			this.feedbackMessage = null;
			this.error = false;
			this.success = false;
			this.overlay = false;
			this.loading = false;
		},
		showError(data) {
			this.error = true;
			this.errors = data?.errors || {};
			this.feedbackMessage = this.formatErrors(this.errors)
				|| (typeof data?.message === 'string' && data.message)
				|| 'Er ging iets fout, probeer het opnieuw.';
			this.feedbackTimer = setTimeout(() => this.resetMessage(), 4000);
		},
		async submitForm(e) {
			e.preventDefault();
			if (this.loading) return;

			this.resetMessage();
			this.errors = {};
			this.overlay = true;
			this.loading = true;

			try {
				const formData = new FormData(e.currentTarget || e.target);
				if (this.csrfName && this.csrfToken) {
					formData.set(this.csrfName, this.csrfToken);
				}

				if (this.recaptchaSiteKey) {
					await new Promise(resolve => window.grecaptcha.ready(resolve));
					const token = await window.grecaptcha.execute(this.recaptchaSiteKey, { action: 'contact' });
					formData.set('g-recaptcha-response', token);
				}

				const response = await axios({
					method: 'post',
					url: '/actions/contact-form/send',
					responseType: 'json',
					data: formData,
					headers: { Accept: 'application/json' },
				});

				if (response.data?.success !== true) {
					this.showError(response.data);
					return;
				}

				this.success = true;
				this.feedbackMessage = 'Bedankt voor je bericht, we proberen z.s.m. te reageren.';
				this.feedbackTimer = setTimeout(() => {
					this.formData = { name: '', email: '', subject: '', message: '' };
					this.resetMessage();
				}, 5000);
			} catch (error) {
				this.$logger('Vue/component/contact-form/submitForm failed', 'error');
				this.showError(error?.response?.data);
			} finally {
				this.loading = false;
			}
		},
	}
} 
</script>

<style scoped>
	.overlay {
		position: absolute;
		top: 0;
		height: 100%;
		width: 100%;
		z-index: 999;
		background-color: rgba(255, 255, 255, 0.9);
	}
</style>
